module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti@2-d818f5f990c90bf212fcbd62c3645231.jpg";